/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import LiteraryWorkPage from 'flarum/orell-articles/components/LiteraryWorkPage';
import LiteraryWorkState from 'flarum/orell-articles/states/LiteraryWorkState';
import LiteraryWorkPageReviews from '../components/LiteraryWorkPageReviews';

export default function () {
	extend(LiteraryWorkPage.prototype, 'viewItems', function (items) {
		const work = this.literaryWorkState.literaryWork;

		if (!work) return;

		items.add('reviews', <LiteraryWorkPageReviews work={work} />, 50);
	});

	extend(LiteraryWorkState.prototype, 'params', function (params) {
		params.include = (params.include ? params.include + ',' : 'articles,') + 'mainArticle.ownReview,mainArticle.ownReview.discussion';
	});
}
